import { DOCTYPES } from '@/constants/doctypes.ts'
import { createDoctypeListDetailRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  detail: routeFileDetail,
  home: routeFilesHome,
  root: routeFilesRoot,
} = createDoctypeListDetailRoutes({
  detailName: 'fileDetail',
  doctype: DOCTYPES.FILE,
  homeName: 'files-home',
  path: 'files',
  views: {
    detail: async () => await import('@/components/viewsExternal/files/ViewFile.vue'),
    list: async () => await import('@/components/viewsExternal/files/FileView.vue'),
  },
})

export { routeFileDetail, routeFilesHome, routeFilesRoot }
